var fields=["name", "field", "investment", "risk", "time", "objective", "sales"];

export function calculateData(products, rules, query) {
  //query [[[key],[value]]]
  //rules [{rule, action, value}]
  //products [{product, rating, ratingMap, [fields...]}]
  
  //prepare special rules
  var gradientRules = rules.filter(function(r) { return r.action == "gradient"}).reduce(function(p,c) { p[c.rule[0]] = c; return p; }, {});
  var secondaryMap = rules.filter(function(r) { return r.action == "secondary"}).reduce(function(p,c) { p[c.rule[0]] = c.value; return p; }, {});
  var secondaryDefault = 1;
  var gradientAdder = 0.5;
  
  var ratedproducts = products;
  ratedproducts.forEach(function(p, i) {
    p.index = i;
    query.forEach(function(q) {
      var qkey = q[0]; //querykey
      var qval = q[1]; //queryvalue
      var match = (p[qkey].split(",").reduce(function(p, pval, i) { return pval == qval ? p + ( i == 0 ? 1 : (secondaryMap[qkey] || secondaryDefault) ) : p }, 0));
      
      p.ratingMap[qkey] = (p.ratingMap[qkey] || 0) + match;
      
      //match gradient rule
      var grule = gradientRules[qkey];
      if (grule) {
        var gvalues = grule.value.split(",");
        var idx1 = gvalues.indexOf(qval);
        var idx2 = gvalues.indexOf(p[qkey]);
        if (Math.abs(idx1-idx2)==1) { //gradient currently distance 1 only
          p.ratingMap[qkey] += gradientAdder;
        }
      }
      p.rating += match;
      
    });
    
  });
  
  //rate products
  ratedproducts.forEach(function(rp){
    var val = 0;
    for (var i=0,ilen=rules.length; i<ilen; i++) {
      var r = rules[i];
      var ruleFirst = r.rule[0];
      
      //match exclusive rule
      if (r.action == "exclusive") {
        var values = query.reduce(function(p, c) {
          if (c[0] == ruleFirst)
            p.push(c[1]);
          return p;
        }, [])
        
        if (values.length && values.indexOf(rp[ruleFirst]) == -1) {
          Object.keys(rp.ratingMap).forEach(function(ratingKey) {
            rp.ratingMap[ratingKey] = 0;
          });
          val = 0;
        }
      }
      
      //calculate product value
      var m = r.rule.reduce(function(p,c) { return p&&rp.ratingMap[c] > 0 },true);
      if (m && r.action == "factor") {
        val += rp.ratingMap[ruleFirst] * r.value;
      } 
    }
    rp.rating = val;
  })
  
  //exclude products with no rating
  ratedproducts=ratedproducts.filter(function(p,i,a) {
    return p.rating > 0;
  })
   
  //priority sorting based on sales
  ratedproducts.sort(function(a,b) { 
    var d = b.rating - a.rating;
    if (d==0) return b.sales - a.sales;
    return d;
  });
  
  return ratedproducts;
}

export function readProducts(products) {
	return products
		.slice(1)
		.filter(function(row) {
			return row[0] != "";
		})
		.map(function(p) {
			var np = {
				product: p,
				rating: 0,
				ratingMap: []
			};
			fields.forEach(function(f,i) {
				np[f]=p[i];
			});

			return np;
		});
}

/**
 * accepts the current key => value object form php and transforms it to an normal mapped array
 * @param {Object} products
 */
export function convertProductsToRatedProducts(products) {
	return products.map(p => {
		var np = {
			product: p,
			rating: 0,
			ratingMap: {}
		};
		fields.forEach(function (f, i) {
			np[f] = p[f];
		});
		return np
	})
}

/**
 * calculates the risk of three questions
 * @param {Array} answers
 * @param {Array} questionRules
 * @returns {Object} item or null
 */
export function calcualteRisk(answers, questionRules) {
	var result = questionRules.filter(function(r) {
		//we have currently every possibility in questionRules, so exact match is enough, ranking is not required
		if (
			r.q1 == answers[0]
			&& r.q2 == answers[1]
			&& r.q3 == answers[2]
		) {
			return true
		}
		return false
	})

	//this will return an item or null
	return result[0] ? result[0]['risk'] : null
}
